import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export default function ReturnToTechModal({ serviceCall, isOpen, onClose, onConfirm }) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) {
      setReason(serviceCall?.techInfoRequestReason || '');
    }
  }, [isOpen, serviceCall]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(reason.trim());
  };

  if (!isOpen || !serviceCall) return null;

  const client = serviceCall.client;
  const isCspire = !!serviceCall.isCspire;
  const cspireWorkOrder = serviceCall.cspireWorkOrder;
  const displayName = isCspire
    ? (cspireWorkOrder?.site?.locationName || cspireWorkOrder?.locationName || 'C Spire')
    : (client?.companyName || `${client?.contactFirstName || ''} ${client?.contactLastName || ''}`.trim() || 'N/A');

  return (
    <div className="fixed inset-0 z-[70] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          onClick={onClose}
        />
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <form onSubmit={handleSubmit}>
            <div className="bg-yellow-50 px-4 py-5 sm:px-6 border-b border-yellow-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-gray-900">
                  Return to Technician
                </h3>
                <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
              <div className="mt-2">
                <p className="text-sm text-gray-600">
                  <span className="font-medium">{displayName}</span>
                  {!isCspire && client?.city && client?.state && (
                    <>
                      <span className="mx-2">&bull;</span>
                      {client.city}, {client.state}
                    </>
                  )}
                </p>
              </div>
            </div>

            <div className="px-4 py-5 sm:p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Reason for return <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  rows={4}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-yellow-500 focus:border-yellow-500"
                  placeholder="Explain what additional info or edits are needed (e.g., need the air filter part number)."
                  required
                  autoFocus
                />
                <p className="mt-1 text-xs text-gray-500">
                  The technician will see this request in their Attention Needed list.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
                disabled={!reason.trim()}
              >
                Send to Tech
              </button>
              <button
                type="button"
                onClick={onClose}
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
